module.exports = __webpack_public_path__ + "img/induction.a4bb49f5.jpg";